var map = {
	"./congxinshengchengIcon_h.png": "./src/components/aiChat/images/icon/congxinshengchengIcon_h.png",
	"./copyIcon_h.png": "./src/components/aiChat/images/icon/copyIcon_h.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/aiChat/images/icon sync recursive ^\\.\\/.*_h\\.png$";